<template>
    <section class="farmerContainer">
        <div class="container">
            <div class="offset-lg-1 col-lg-10">
                <div class="breadcrumbs">
                    <ul class="breadcrumbs-list">
                        <li class="breadcrumbs-list-item">
                            <a href="#">Orders</a>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0.528514 0.528636C0.788864 0.268287 1.21097 0.268287 1.47132 0.528636L5.47132 4.52864C5.73167 4.78899 5.73167 5.2111 5.47132 5.47145L1.47132 9.47145C1.21097 9.7318 0.788864 9.7318 0.528514 9.47145C0.268165 9.2111 0.268165 8.78899 0.528514 8.52864L4.05711 5.00004L0.528514 1.47145C0.268165 1.2111 0.268165 0.788986 0.528514 0.528636Z"
                                    fill="#E0C7B1" />
                            </svg>
                        </li>
                        <li class="breadcrumbs-list-item" v-if="order">
                            <router-link :to="{name: 'offtaker.shippingdetails', params: { id: order.id }}">Shipping</router-link>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0.528514 0.528636C0.788864 0.268287 1.21097 0.268287 1.47132 0.528636L5.47132 4.52864C5.73167 4.78899 5.73167 5.2111 5.47132 5.47145L1.47132 9.47145C1.21097 9.7318 0.788864 9.7318 0.528514 9.47145C0.268165 9.2111 0.268165 8.78899 0.528514 8.52864L4.05711 5.00004L0.528514 1.47145C0.268165 1.2111 0.268165 0.788986 0.528514 0.528636Z"
                                    fill="#E0C7B1" />
                            </svg>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <router-link :to="{ name: 'offtaker.orderpayment'}" class="breadcrumbs-active">Payment</router-link>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0.528514 0.528636C0.788864 0.268287 1.21097 0.268287 1.47132 0.528636L5.47132 4.52864C5.73167 4.78899 5.73167 5.2111 5.47132 5.47145L1.47132 9.47145C1.21097 9.7318 0.788864 9.7318 0.528514 9.47145C0.268165 9.2111 0.268165 8.78899 0.528514 8.52864L4.05711 5.00004L0.528514 1.47145C0.268165 1.2111 0.268165 0.788986 0.528514 0.528636Z"
                                    fill="#E0C7B1" />
                            </svg>
                        </li>
                        <li class="breadcrumbs-list-item">
                            <!-- <a href="#" >Confirmation</a> -->
                            Confirmation
                        </li>
                        <li class="breadcrumbs-list-item">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M0.528514 0.528636C0.788864 0.268287 1.21097 0.268287 1.47132 0.528636L5.47132 4.52864C5.73167 4.78899 5.73167 5.2111 5.47132 5.47145L1.47132 9.47145C1.21097 9.7318 0.788864 9.7318 0.528514 9.47145C0.268165 9.2111 0.268165 8.78899 0.528514 8.52864L4.05711 5.00004L0.528514 1.47145C0.268165 1.2111 0.268165 0.788986 0.528514 0.528636Z"
                                    fill="#E0C7B1" />
                            </svg>
                        </li>
                    </ul>
                </div>

                <div class="shippingContainer margin_top_xl margin_bottom_md">
                    <div class="row">
                        <div class="col-lg-6">
                            <h4 class="font-bold font-lg">Make Payment</h4>
                            <div class="shippingContainer__subheader margin_top_lg">
                                <h4 class="shippingContainer__subheader__title font-bold font-sm caps_upper">Shipping Details</h4>
                                <div class="shippingContainer__subheader__border"></div>
                            </div>

                            <div class="margin_top_lg">
                                <div class="row mb-3">
                                    <div class="col-12 font-bold font-md">{{ address ? address.full_name : ''}}</div>
                                </div>
                                <div class="row margin_bottom_md">
                                    <div class="col-6">{{address ? address.address : ''}},{{address ? address.city : ''}}, {{address && address.state ? address.state.name : ''}}, Nigeria</div>
                                    <div class="col-6">{{address.email}} <br>{{address.phone_no}}</div>
                                </div>
                                <!-- <button class="btn-link">Edit Address</button> -->
                            </div>

                            <!-- <div class="shippingContainer__subheader margin_top_lg">
                                <h4 class="shippingContainer__subheader__title font-bold font-sm caps_upper">Payment Details</h4>
                                <div class="shippingContainer__subheader__border"></div>
                            </div> -->

                            <!-- <div class="">
                                <form action="">
                                    <div class="form-group">
                                        <label class="control-label font-sm">Name on card</label>
                                        <input type="text" class="form-control" placeholder="Raymond Dokpesi">
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label font-sm">Card Number</label>
                                        <input type="number" class="form-control" placeholder="4534 4141 4141 4141">
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="form-group">
                                                <label class="control-label font-sm">Expiry date</label>
                                                <input type="text" class="form-control" placeholder="date/year">
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group">
                                                <label class="control-label font-sm">CVV/CVC Code</label>
                                                <input type="password" class="form-control" placeholder="***">
                                            </div>
                                        </div>
                                    
                                    </div>
                                </form>
                            </div> -->

                            <div class="mt-1 margin_bottom_lg">
                                <submit-button class="btn btn-secondary col-12" @click="initPaystack">Complete purchase</submit-button>
                            </div>
                        </div>

                        <div class="col-lg-6" v-if="order">
                            <order-summary @makePayment="triggerPayment" :order="order" />
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </section>
</template>

<script>
import OrderSummary from '@/components/off-taker/order/OrderSummary';
import { mapState } from 'vuex';

export default {
    data() {
        return {
           payment: false,
           addresses: [],
           loadingAddress: false,
           loadingOffer: false,
           creatingOrder: false,
           order: '',
           verifyingTransaction: false
        }
    },
    computed: {
        ...mapState(['user']),
        ...mapState('offtaker',['cart']),
        subTotal() {
            return this.order.reduce((sum, item) => {
                return sum + (item.crop.agg_kg_price * item.quantity)
            }, 0)
        },
        tax() {
            return this.subTotal * 0.05
        },
        total() {
            return this.subTotal + this.tax
        },
        
        cropUrl() {
            // return this.offer && this.offer.crop && this.offer.crop.images ? this.offer.crop.images[0].url : ''
        },
        address() {
            return this.addresses.length !== 0 ? this.addresses[0] : ''
        }
    },
    methods: {
        triggerPayment() {
            this.initPaystack();
        },
        initPaystack() {
            const email = this.user.email;
            const amount = Math.ceil( this.order.total_amount * 100 );
            const phoneNo = this.user.phoneNo;
            const ref = this.order.reference;
            var handler = PaystackPop.setup({
            key: 'pk_test_c7db2dcc123ac89e066f89540563af56019e6321',
            email: email,
            amount: amount,
            currency: "NGN",
            ref: ref,             
            // ref: ''+Math.floor((Math.random() * 1000000000) + 1), // generates a pseudo-unique reference. Please replace with a reference you generated. Or remove the line entirely so our API will generate one for you
            metadata: {
                custom_fields: [
                    {
                        display_name: "Mobile Number",
                        variable_name: "mobile_number",
                        value: phoneNo
                    }
                ]
            },
            callback: function(response){
                console.log('paystack payment ', response)
                this.verifyTransaction();
                alert('success. transaction ref is ' + response.reference);
            }.bind(this),
            onClose: function(){
                // alert('window closed');
            }
            });
            handler.openIframe();

        },
        
        getAddress() {
            this.loadingAddress = true;
            this.$http.get('addresses')
            .then((response) => {
                this.addresses = response.data
                this.edit = false;
                this.$log(response.data)
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.loadingAddress = false;
            })
        },
        createOrder() {
            this.creatingOrder = true;
            const obj = {
                shipping_amount: 0,
                tax_amount: this.tax
            }
            this.$http.post('crop_orders', obj)
            .then((response) => {
                this.order = response.data;
                this.$log('Order created ', response.data)
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.creatingOrder = false;
            })
        },
        getOrder() {
            this.creatingOrder = true;
            this.$http.get(`crop_orders/${this.$route.params.id}`)
            .then((response) => {
                this.order = response.data;
                this.$log('Order created ', response.data)
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.creatingOrder = false;
            })
        },
        verifyTransaction() {
            this.verifyingTransaction = true;
            this.$http.get(`crop_orders/${this.order.id}/verify`)
            .then((response) => {
                this.$log('verification response ', response.data)
                this.$router.push({
                    name: 'offtaker.paymentconfirmation',
                    params: {
                        id: this.order.id
                    }
                })
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.verifyingTransaction = false
            })
        }
    },
    mounted() {
        const getId = document.getElementById('paystack')
        if(!getId) {
            let paystackScript = document.createElement('script')
            paystackScript.setAttribute('src', 'https://js.paystack.co/v1/inline.js')
            paystackScript.setAttribute('id', 'paystack');
            document.head.appendChild(paystackScript)
        }
    },
    
    created() {
        this.getAddress();
        this.getOrder();
        // this.createOrder();
    },
    components: {
        OrderSummary
    }
}
</script>


<style>

</style>